import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterDifficultyCategories.module.scss";
import {useFilterDifficultyCategoriesLogic} from "./FilterDifficultyCategories.logic";
import {FilterDifficultyCategory} from "../filter-difficulty-category/FilterDifficultyCategory";
import {FilterDifficultyControls} from "../filter-difficulty-controls/FilterDifficultyControls";

export const FilterDifficultyCategories: VoidFunctionComponent = () => {
  const {difficultyCategoryIds} = useFilterDifficultyCategoriesLogic();
  return (
    <ol className={s.container}>
      <li>
        <FilterDifficultyControls/>
      </li>
      {difficultyCategoryIds.map((difficultyCategoryId) =>
        <FilterDifficultyCategory difficultyCategoryId={difficultyCategoryId} key={`filter-difficulty-category-${difficultyCategoryId}`}/>)}
    </ol>
  );
}
